/**
 * Keycaps: `<Keys k="g l" />` renders one `<kbd>` per key (`g` `l`), never a run of letters.
 * Hidden on touch-only devices by the global `kbd` rules' container (`.lk-keys`).
 */
export function Keys({ k, className = '' }: { k: string; className?: string }) {
  return (
    <span className={`lk-keys${className ? ` ${className}` : ''}`} aria-hidden="true">
      {k.split(' ').map((key, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: a chord may repeat a key
        <kbd key={i}>{key}</kbd>
      ))}
    </span>
  )
}

/** A hint bar: keys then what they do (`j k` move · `⏎` open). */
export function KeyHints({ hints, label }: { hints: [string, string][]; label: string }) {
  return (
    <span className="lk-hints" role="note" aria-label={label}>
      {hints.map(([k, what]) => (
        <span key={k} className="lk-hint">
          <Keys k={k} />
          <span aria-hidden="true">{what}</span>
        </span>
      ))}
    </span>
  )
}
